import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ASSET_POST_PUBLISHING_NOT_YET_SUPPORTED,
  ScheduleParams,
  ScheduleResponse,
} from 'api/post';
import List from 'components/workflowOptions/postsSelection/posts/List';
import style from './postSchedulingResults/PostsSchedulingResults.module.scss';
import { PostDetail } from 'types/PostDetail';
import { STATUS } from '@kontentino/kontentino-constants/Posts';

export function scheduleWarningMessage(
  value: ScheduleResponse[string],
  t: (key: string) => string,
): string {
  if (value.code === ASSET_POST_PUBLISHING_NOT_YET_SUPPORTED) {
    return t('errors.assetPostPublishingNotYetSupported');
  }

  return value.message || (typeof value.data === 'string' ? value.data : '');
}

type Props = {
  scheduleResponse: ScheduleResponse;
  scheduleChosenMethod?: ScheduleParams['chosenMethod'];
  posts: PostDetail[];
};

const PostsSchedulingResults: FC<Props> = ({
  scheduleResponse,
  posts,
  scheduleChosenMethod,
}) => {
  const { t } = useTranslation();

  function getScheduledPosts() {
    return posts
      .filter((post) => !!scheduleResponse?.[post.id])
      .map((post) => ({
        ...post,
        status: scheduleResponse?.[post.id].status
          ? scheduleChosenMethod === 'export'
            ? STATUS.EXPORTED
            : STATUS.SCHEDULED
          : post.status,
      }));
  }

  function getWarningMessages() {
    return Object.fromEntries(
      Object.entries(scheduleResponse).map(([key, value]) => [
        key,
        scheduleWarningMessage(value, t),
      ]),
    );
  }

  const scheduledPosts = getScheduledPosts();
  const warningMessages = getWarningMessages();

  return (
    <List
      className={style.postSchedulingResults}
      posts={scheduledPosts}
      warningMessages={warningMessages}
      selectedPosts={scheduledPosts}
      onSelectPost={() => null}
    />
  );
};

export default PostsSchedulingResults;
